import React, { useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import BanquetDetailExperience from "../components/banquet/BanquetDetailExperience.jsx";
import WhatsAppInquiryBar from "../components/banquet/WhatsAppInquiryBar.jsx";
import { samplePublicBanquetDemo } from "../data/samplePublicBanquetDemo.js";

export default function SamplePublicBanquetDetailPage() {
  const location = useLocation();
  const [selectedContext, setSelectedContext] = useState(null);
  const banquet = samplePublicBanquetDemo;

  const pageUrl = useMemo(() => {
    if (typeof window === "undefined") {
      return `${location.pathname}${location.search}`;
    }

    return `${window.location.origin}${location.pathname}${location.search}`;
  }, [location.pathname, location.search]);

  const handleDateSelect = (date, slotState) => {
    const slotLabel = !slotState.lunch && !slotState.dinner
      ? "Both lunch and dinner available"
      : slotState.lunch && !slotState.dinner
        ? "Lunch booked, dinner available"
        : !slotState.lunch && slotState.dinner
          ? "Lunch available, dinner booked"
          : "Fully booked";

    setSelectedContext({ date, slotLabel });
  };

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#f5f7f4] pb-36 sm:pb-28">
      <meta name="robots" content="noindex, nofollow" />
      <div className="mx-auto max-w-7xl px-3 pb-10 pt-6 sm:px-4 sm:pt-8">
        <div className="mb-6 flex min-w-0 flex-wrap items-center gap-3 text-sm text-slate-500">
          <Link to="/" className="hover:text-emerald-600">Home</Link>
          <span>/</span>
          <Link to="/banquets" className="hover:text-emerald-600">Banquets</Link>
          <span>/</span>
          <span className="min-w-0 break-words text-slate-900">{banquet.name}</span>
        </div>

        <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-semibold text-amber-900">
          Sample public banquet detail page. This demo uses placeholder media and DecorZoom lead buttons only.
        </div>

        <div className="mt-8">
          <BanquetDetailExperience
            banquet={banquet}
            selectedContext={selectedContext}
            onDateSelect={handleDateSelect}
            pageUrl={pageUrl}
            sourceLabel={banquet.googleSourceLabel}
          />
        </div>
      </div>

      <WhatsAppInquiryBar
        banquet={banquet}
        selectedDate={selectedContext?.date}
        selectedSlot={selectedContext?.slotLabel}
        pageUrl={pageUrl}
      />
    </div>
  );
}
